//WE.Flow.Html.Models.HomeConfigModel
import { HomeConfig } from "./HomeConfig";

export class HomeConfigModel {
    productId: string = "";
    config: HomeConfig = null;
}
